<template>
	<div class="wrapper content">
		<div class="detail-cont">
			<div class="fx fx-y-center">
				<div class="title fx w120 m-r-5"><p class="ask-cont"></p><span class="fx-fill">微信地址</span></div>
				<div class="fx-fill">
					{{openUrl}}/index_vmall?mid={{userInfo.mid}}&scope=snsapi_userinfo
				</div>
			</div>
			<div class="m-t-20 fx" v-show="qrcode">
				<div class="title fx w120 m-r-5"><p class="ask-cont"></p><span class="fx-fill">微商城预览</span></div>
				<div class="fx-fill">
					<div id="qrcode"></div>
				</div>
			</div>
			<z-input title="商城名称" class="m-t-20" v-model="params.name" :isMust=true></z-input>
			<div class="fx m-t-20 vmall-type">
				<p class="fx w120 m-r-5"><i class="ask">*</i><span class="fx-fill">商城模板</span></p>
				<div>
					<div class="vmall-pic" :class="{'active' : params.type == 2}" @click="handleVmallType(2)">
						<img src="../../../assets/img/vmall.jpg" width="56" height="96" />
						<div class="vmall-del"><img src="../../../assets/img/vmall.jpg" /></div>
					</div>
					<p class="type-mane">标准版</p>
				</div>
				<div class=" m-l-30">
					<div class="vmall-simple-pic" :class="{'active' : params.type == 1}" @click="handleVmallType(1)">
						<img src="../../../assets/img/vmall_simple.jpg" width="56" height="96" />
						<div class="vmall-simple-del"><img src="../../../assets/img/vmall_simple.jpg" /></div>
					</div>
					<p class="type-mane">精简版</p>
				</div>
			</div>
			<z-input title="客服电话" class="m-t-20" v-model="params.consumer_phone" :isMust=true ></z-input>
			<div class="fx fx-y-center m-t-20">
				<div class="title fx-shrink fx w120 m-r-5"><p class="ask-cont"></p><span class="fx-fill">售后服务</span></div>
				<div class="fx-fill">
					<div class="edit-width">
						<div id="after_sale_info" placeholder="请在这里填写售后服务内容"></div>						
					</div>
				</div>
			</div>
			<!--<z-input title="分享标题" class="m-t-20" v-model="params.share_title"></z-input>
			<z-input title="分享描述" class="m-t-20" v-model="params.share_description"></z-input>
			<div class="fx fx-y-center m-t-20">
				<div class="title fx w120 m-r-5"><p class="ask-cont"></p><span class="fx-fill">分享图标</span></div>
				<z-up-file :listArr="picList"></z-up-file>
				<div class="pic-tips m-l-10">建议尺寸：200*200</div>
			</div>-->
		</div>
		<div class="m-t-30 fx">
			<p class="w120 m-r-5 fx-shrink"></p>
			<a class="z-btn z-btn-primary b-r-3" @click="handleValidation()">保存配置</a>
		</div>
	</div>
</template>
<script>
	import { mapActions, mapState } from 'vuex'
	import { OPEN_URL } from '@/config.js'
	export default {
		name: 'Configure',
		components: {},
		data() {
			return {
				editor:null,
				openUrl : OPEN_URL,
				qrcode: null,
				options: [{
					value: 1,
					text: '简易版'
				}, {
					value: 2,
					text: '普通版'
				}],
				params: {
					id: null,
					name: '',
					consumer_phone: '',
					after_sale_info: '',
					type: '',
					share_title: '',
					share_description: '',
					share_logo: ''
				},
			}
		},
		mounted() {
			//初始化编辑器
			this.editor = this.$editorInit('#after_sale_info')
			this.handleGetVmallConfig();
		},
		/*
		 * 属性计算
		 */
		computed: {
			...mapState({
				userInfo: state => state.users.userInfo
			})
		},
		/*
		 * 事件处理
		 */
		methods: {
			//生成二维码
			handleQrcode() {
				let qrcodeUrl = this.openUrl +"/index_vmall?mid=" + this.userInfo.mid + "&scope=snsapi_userinfo";
				if(this.qrcode) return this.qrcode.makeCode(qrcodeUrl);
				
             	this.qrcode = this.$qrcodeInit({
             		id: 'qrcode',
             		text: qrcodeUrl,
             		width: 130,
             		height: 130
             	});
			},
			
			
			//提交验证...
			handleValidation() {
				this.params.after_sale_info = this.editor.txt.html();

				if(!this.params.name) return this.$warning('请输入商城名称...');
				if(!this.params.type) return this.$warning('请选择商城类型...');
				if(!this.params.consumer_phone) return this.$warning('请输入客服电话...');

				this.handleSave();
			},
			//保存
			async handleSave() {
				try{
					await this.saveVmallConfig(this.params)
					this.$success('保存成功');
					this.handleGetVmallConfig()
				}catch(e){
					this.$errorMsg(e)
				}
			},

			//获取商城配置信息
			async handleGetVmallConfig() {
				try{
					const data = await this.getVmallConfig()
					if(data){
						this.params = data
						this.editor.txt.html(data.after_sale_info);
						this.handleQrcode()
					}
					
				}catch(e){
					this.$errorMsg('获取商城配置信息失败')
				}
			},

			//选择商城类型
			handleVmallType(type) {
				this.params.type = type;
			},

			...mapActions(['getVmallConfig', 'saveVmallConfig']),
		},
	}
</script>
<style lang="scss" scoped>
	@import "src/assets/css/common.scss";
	#content {
		min-height: px-em(400px);
	}
	
	.edit-width {
		width: 640px !important;
	}
	
	.detail-cont {
		width: 600px;
		.question-api {
			position: relative;
			width: px-em(120px);
			height: px-em(120px);
			border: 1px solid $color-border;
			overflow: hidden;
			&:hover {
				.edit {
					opacity: 1;
				}
			}
			input {
				display: inline-block;
				width: px-em(120px);
				height: px-em(120px);
				opacity: 0;
				position: relative;
				z-index: 99;
				cursor: pointer;
			}
			img {
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
			}
			.edit {
				opacity: 0;
				position: absolute;
				top: 0;
				left: 0;
				bottom: 0;
				right: 0;
				width: 100%;
				height: 100%;
				background: rgba(0, 0, 0, 0.3);
				transition: all 0.2s ease;
				.icon {
					transition: all 0.2s ease;
					color: #fff;
					font-size: px-em(32px);
				}
			}
		}
		.vmall-type {
			.type-mane {
				width: 60px;
				text-align: center;
				margin-top: 10px;
			}
			.vmall-pic,
			.vmall-simple-pic {
				cursor: pointer;
				width: 60px;
				height: 100px;
				border: 2px solid $color-border;
				transition: all 0.2s ease;
				position: relative;
				&:hover {
					border-color: $color-main;
					.vmall-del,
					.vmall-simple-del {
						visibility: visible;
						opacity: 1;
					}
				}
				&.active {
					border-color: $color-main;
					@extend .icon;
					&:after {
						content: "\e63f";
						position: absolute;
						top: 0;
						left: 0;
						z-index: 2;
						width: 100%;
						height: 100%;
						background: rgba(0, 0, 0, 0.3);
						text-align: center;
						line-height: 100px;
						color: $color-white;
						font-size: 30px;
					}
				}
			}
			.vmall-del,
			.vmall-simple-del {
				visibility: hidden;
				position: absolute;
				top: -200px;
				left: 50px;
				z-index: 9;
				transition: all 0.2s ease;
				opacity: 0;
				padding: 20px;
				img {
					border: 1px solid $color-main;
					width: 260px;
					height: auto;
				}
			}
		}
	}
	
	@media only screen and (min-width:0px) and (max-width:640px) {
		.wrapper{
			min-width: px-em(1400px);
		}
	}
	
</style>


// WEBPACK FOOTER //
// Configure.vue?b50ef8b0